var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{attrs:{"color":"#36b928","dark":"","right":"","fixed":"","bottom":"","fab":"","href":`https://wa.me//5511975386175?text=Preciso%20tirar%20dúvidas%20com%20a%20equipe%20do%20Simplificador`,"target":"_blank"}},[_c('v-icon',{attrs:{"large":"","color":"#ffffff"}},[_vm._v("fab fa-whatsapp")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }